import jobs from '../data/jobs.json';

const useJobs = () => {
  const getJobs = () => jobs;
  const getJobById = ({ jobId }) => jobs.filter(({ id }) => id === jobId);
  return { getJobs, getJobById };
};

export { useJobs };
